import * as angular from 'angular';
import { TransitionService } from '@uirouter/angularjs';

import { toggleEditMode } from '../../../common/events';
import { ComponentDefinition } from '../../../models';
import { IRootScope } from 'IRootScope';
import { SubPageScope } from '../SubPageScope';

class MoreToolsStateController implements angular.IComponentController {
    beginDate: string;
    currentState: angular.ui.IState;
    endDate: string;
    formController: angular.IFormController;
    isEditMode: boolean;
    selectedItem: any;

    /**
     * Sub page scope, provided by the sub page.
     */
    readonly subPageScope: SubPageScope;

    static $inject = [
        '$scope',
        '$state',
        '$transitions',
        '$rootScope'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$state: angular.ui.IStateService,
        private _$transitions: TransitionService,
        private _$rootScope: IRootScope
    ) {
    }

    $onInit() {
        this.isEditMode = this._$rootScope.isEditMode;
        this.currentState = this._$state.current;

        this._$scope.$on(toggleEditMode, () => {
            this.isEditMode = this._$rootScope.isEditMode;
        });

        this._$transitions.onSuccess({}, (transition) => {
            this.currentState = transition.to() as angular.ui.IState;
        });
    }

    onCancelClick() {
        if (this.subPageScope?.onCancelClick) {
            this.subPageScope.onCancelClick();
        }
    }

    unselect() {
        this.selectedItem = null;
    }
}

export const wtMoreToolsState: ComponentDefinition = {
    componentId: 'wtMoreToolsState',
    controller: MoreToolsStateController,
    template: require('./moreToolsState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};